<template>
  <Teleport to="body">
    <Transition name="toast-fade">
      <div
        v-if="toastState.visible"
        class="app-toast"
        :class="`app-toast--${toastState.type}`"
        role="status"
        aria-live="polite"
      >
        <span class="app-toast-dot" aria-hidden="true"></span>
        <span class="app-toast-message">{{ toastState.message }}</span>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { useToast } from '@/composables/useToast'

const { toastState } = useToast()
</script>

<style scoped>
.app-toast {
  position: fixed;
  top: 28px;
  left: 50%;
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 220px;
  max-width: min(520px, calc(100vw - 32px));
  padding: 13px 18px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.94);
  color: var(--text-dark);
  box-shadow: 0 16px 42px rgba(15, 39, 64, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.7);
  transform: translateX(-50%);
}

.app-toast-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2ecc71;
  flex-shrink: 0;
}

.app-toast--error .app-toast-dot {
  background: #e74c3c;
}

.app-toast-message {
  font-size: 0.95rem;
  line-height: 1.5;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}
</style>
